module.exports = __webpack_public_path__ + "img/202-taiwan.15e52c31.svg";